import { Container, Grid } from 'semantic-ui-react'

import styles from './Error.module.css'
import { prodErrorContent } from '@view/classes/ErrorBoundary'
import ErrorSvg from './ErrorSvg'
import HomeButton from './HomeButton'

type ErrorProps = {
	errorContent: string
}

export default function Error({ errorContent = prodErrorContent, themeColour }: ErrorProps) {
	const date = new Date()

	return (
		<Container className={`fodContainer`} as="section" fluid={true}>
			<Grid>
				<Grid.Row centered columns={1}>
					<Grid.Column width={8} textAlign="center">
						<Grid.Row className={styles.errorRow}>
							<ErrorSvg fill={themeColour} />
							<h1 className={styles.errorHeading}>We seem to have a problem with the page</h1>
							<span className={styles.errorSubText}>{errorContent}</span>
							<span
								className={styles.errorDateMessage}
							>{`Occurred: ${date.toLocaleDateString()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`}</span>
							<HomeButton background={themeColour} />
						</Grid.Row>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Container>
	)
}
